import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  addCard,
  addCategoryOrDeck,
  deleteCard,
  deleteDeck,
  editCard,
  getAllCategories,
  getAllDecks,
  getDeckById,
  parseCSV,
  updateDeck,
} from "../../endpoints/FlashCards/functions";
import ModifyCard from "../../components/Modals/ModifyCard";
import ModDeckContent from "../../components/Mods/Deck/ModDeckContent";

const ModDeckPage = (props) => {
  const { deckId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [deleting, setDeleting] = useState(false);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [file, setFile] = useState(null);
  const [cards, setCards] = useState([]);
  const [cardModal, setCardModal] = useState("");
  const [deckOptions, setDeckOptions] = useState([]);
  const [index, setIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const visibleCards = cards.filter((item) => !item.delete);
  const [changesMade, setChangesMade] = useState({
    deck: false,
    cards: false,
  });
  const [deck, setDeck] = useState({
    id: deckId !== "new" ? deckId : null,
    category: location.state ? location.state.category : 0,
    name: "",
    subtitle: "",
  });

  useEffect(() => {
    async function getCategories() {
      try {
        let result = await getAllCategories(props.token);
        const formattedCats = result.map((item) => {
          return {
            value: item.id,
            label: item.name,
          };
        });
        setCategoryOptions(formattedCats);
      } catch (error) {
        console.log("Error at getCategories", error);
      }
    }
    async function getDecks() {
      try {
        let result = await getAllDecks(props.token);
        setDeckOptions(result);
      } catch (error) {
        console.log("Error at getDecks", error);
      }
    }
    setLoading(true);
    getCategories();
    getDecks();
    setLoading(false);
  }, [props.token]);

  useEffect(() => {
    if (deckId !== "new") {
      async function getDeck() {
        setLoading(true);
        try {
          let result = await getDeckById(props.token, deckId);
          setDeck({
            id: result.deck.id,
            category: result.deck.category.id,
            name: result.deck.name,
            subtitle: result.deck.subtitle,
          });
          setCards(result.cards);
          setLoading(false);
        } catch (error) {
          console.log("Error at getDeck", error);
        }
      }
      getDeck();
    }
  }, [deckId, props.token]);

  function handleRemove() {
    const updatedCards = [...cards];
    if (index !== null && updatedCards[index].id !== undefined) {
      updatedCards[index].delete = true;
    } else {
      updatedCards.splice(index, 1);
    }
    setCards(updatedCards);
    if (changesMade.cards === false) {
      setChangesMade({ ...changesMade, cards: true });
    }
    setCardModal("");
    setIndex(null);
  }

  async function handleDelete() {
    try {
      await deleteDeck(deckId, props.token);
      navigate(-1);
    } catch (error) {
      console.log("Error at handleDelete", error);
    }
  }
  async function parseFile(file) {
    const formData = new FormData();
    formData.append("file", file);
    setChangesMade({ ...changesMade, cards: true });
    try {
      const res = await parseCSV(props.token, formData, deck.id ? deck.id : 0);
      setCards([...cards, ...res]);
    } catch (error) {
      console.log("Error at parseFile", error);
    }
    setFile(null);
  }
  function handleCards(newCards) {
    const newCard = newCards[0];
    const updatedCards = [...cards];
    if (index === null && !newCard.id) {
      newCard.add = true;
      updatedCards.push(newCard);
    } else if (newCard.id) {
      newCard.update = true;
      updatedCards[index] = newCards[0];
    } else if (index !== null) {
      updatedCards[index] = newCard;
    }
    setCards(updatedCards);
    if (changesMade.cards === false) {
      setChangesMade({ ...changesMade, cards: true });
    }
  }

  async function handleSave() {
    let localDeckId = deckId;
    try {
      setSaving(true);
      if (changesMade.deck) {
        if (deckId !== "new") {
          await updateDeck(props.token, deck);
        } else {
          const res = await addCategoryOrDeck(
            "decks",
            props.token,
            deck.name,
            deck.subtitle,
            deck.category,
          );
          setDeck({ ...deck, id: res.id });
          localDeckId = res.id;
        }
      }
      if (changesMade.cards) {
        const editCards = cards
          .filter((item) => item.update && item.id)
          .map((item) => {
            delete item.update;
            return item;
          });
        const addCards = cards
          .filter((item) => item.add)
          .map((item) => {
            item.deck_id = localDeckId;
            delete item.add;
            return item;
          });

        const removeCards = cards
          .filter((item) => item.delete)
          .map((item) => item.id);

        if (editCards.length > 0) {
          editCards.map(async (item) => {
            await editCard(item.id, props.token, item);
          });
        }
        if (addCards.length > 0) {
          if (deckId === "new") {
            addCards.map((item) => {
              item.deck_id = localDeckId;
              return item;
            });
          }
          try {
            await addCard(addCards, props.token);
          } catch (error) {
            console.log("Error at addCard in ModDeckPage", error);
          }
        }
        if (removeCards.length > 0) {
          for (let i = 0; i < removeCards.length; i++) {
            try {
              await deleteCard(removeCards[i], props.token);
            } catch (error) {
              console.log("Error at deleteCard in ModDeckPage", error);
            }
          }
        }
      }
    } catch (error) {
      console.log("Error at handleSave for updateDeck", error);
    }
    setSaving(false);
    navigate(-1);
  }
  return (
    <>
      <ModDeckContent
        deckId={deckId}
        deleting={deleting}
        setDeleting={setDeleting}
        handleDelete={handleDelete}
        deck={deck}
        setDeck={setDeck}
        setChangesMade={setChangesMade}
        changesMade={changesMade}
        categoryOptions={categoryOptions}
        file={file}
        setFile={setFile}
        saving={saving}
        handleSave={handleSave}
        loading={loading}
        parseFile={parseFile}
        setCardModal={setCardModal}
        visibleCards={visibleCards}
        cards={cards}
        setIndex={setIndex}
      />
      <ModifyCard
        show={cardModal}
        setShow={setCardModal}
        decks={deckOptions}
        deck={deck}
        index={index}
        setIndex={setIndex}
        cards={cards}
        handleSave={handleCards}
        handleRemove={handleRemove}
      />
    </>
  );
};

export default ModDeckPage;
